import EditorMarker from './EditorMarker';

export default class EditorTrapMarker extends EditorMarker {
  constructor(scene: Phaser.Scene, x: number = 0, y: number = 0, texture?: string, frame?: number | string) {
    super(scene, x, y, texture, frame);
  }
}
